import 'vue-awesome/icons';
import Echo from 'laravel-echo';
import 'videojs-playlist';
import '@videojs/http-streaming';
import '../sentry';
import {Settings} from 'luxon';
import moment from 'moment';
import 'moment/locale/nl';
import './validation-rules.js';

Settings.defaultLocale = 'nl';
moment.locale('nl');

if (window.pusherAppExternalHost) {
    window.Pusher = require('pusher-js');

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: '1234567890',
        wsHost: window.pusherAppExternalHost,
        wsPort: 443,
        wssPort: 443,
        encrypted: true,
        forceTLS: true,
        enableStats: false,
        disableStats: true,
        enabledTransports: [
            'ws',
            'wss'
        ],
    });

    window.stopListening = () => {
        const channel = window.Echo.channel('blockmessages');

        channel.stopListening('BlockStarted');
        channel.stopListening('BlockFinished');
        channel.stopListening('BlockStateChanged');
        channel.stopListening('BlockDurationChanged');
        channel.stopListening('CeremonyFinished');
        channel.stopListening('CeremonyUpdated');
        channel.stopListening('VolumeUpdated');

        window.Echo.leaveChannel('blockmessages');
    };
}

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

// POLYFILLS
// Event.composedPath
// Possibly normalize to add window to Safari's chain, as it does not?
(function (E, d, w) {
    if (!E.composedPath) {
        E.composedPath = function () {
            if (this.path) {
                return this.path;
            }
            let target = this.target;

            this.path = [];

            while (target.parentNode !== null) {
                this.path.push(target);
                target = target.parentNode;
            }

            this.path.push(d, w);

            return this.path;
        };
    }
})(Event.prototype, document, window);

Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    get: function () {
        return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    }
});
